import { Vector2, Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ERR_INVALID_ARGUMENT } from "../../utils/error";
import { CoordinatesType } from "../view/View";
export class SnapGrid {
    constructor() {
        this.offset = Vector3.Zero();
        this.size = new Vector3(0.1, 0.1, 0.1); //default 10 cm grid.
        this.snapXAxis = true;
        this.snapYAxis = true;
        this.snapZAxis = true;
    }
    updateSize(pRefPos, pView) {
        if (pView == null || pRefPos == null)
            return;
        let tSize = 0.1; //default 10 cm grid.
        const tP1 = pView.projectPoint2(pRefPos, CoordinatesType.Viewer, null, true);
        const tP2 = pView.projectPoint2(pRefPos.add(pView.cameraControl.right.scale(0.001)), CoordinatesType.Viewer, null, true);
        if (tP1 != null && tP2 != null) {
            let tDist = Vector2.Distance(tP1, tP2);
            tSize = 0.001; // start with 1 mm
            //increase size (1mm > 5mm > 1cm > 5cm > 10cm)
            let tDouble = false;
            while (tDist < 5) {
                const tFactor = tDouble ? 2 : 5;
                tDist *= tFactor;
                tSize *= tFactor;
                tDouble = !tDouble;
                if (tSize > 0.1) {
                    tSize = 0.1;
                    break;
                }
            }
        }
        this.size.copyFromFloats(tSize, tSize, tSize);
    }
    snap(pPos, pView) {
        if (pPos == null || pView == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tNewPos = pPos.subtract(this.offset);
        if (this.snapXAxis)
            tNewPos.x = this.size.x * (Math.round(tNewPos.x / this.size.x));
        if (this.snapYAxis)
            tNewPos.y = this.size.y * (Math.round(tNewPos.y / this.size.y));
        if (this.snapZAxis)
            tNewPos.z = this.size.z * (Math.round(tNewPos.z / this.size.z));
        tNewPos.addInPlace(this.offset);
        return (tNewPos);
    }
}
